export default __webpack_public_path__ + "static/media/oxy-gen.8a498893.png";